<template>
    <div class="sidebar-panels__container" id="div_sidebarPanels" :data-active-panel="expandedPanelId">
        <div class="sidebar-panels__content" :data-expanded="expandedPanelId != null" :style="{
            '--sidebar-panel-width': panelWidth + 'px'
        }" :data-resizing="resizing.active">

            <template v-if="expandedPanelId === 'anatomia'">
                <AnatomiaPanel class="fade-in" />
            </template>
            <template v-show="expandedPanelId === 'relatorio'">
                <RelatorioDinamicoPanel class="fade-in" :visible="expandedPanelId == 'relatorio'" />
            </template>
            <!-- <template v-show="expandedPanelId == 'pesquisa'">
                <PesquisaAnotacoesPanel class="fade-in" />
            </template> -->

        </div>
        <div v-if="hasExpandedPanel" class="sidebar-panels__resize-handle" :data-resizing="resizing.active"
            @mousedown.left.prevent="startResizing"></div>
        <span class="close_button" @click="toggleExpanded(null)" v-if="expandedPanelId != null">
            <ArrowDownSvg class="close_button__icon" />
        </span>
        <div class="sidebar-panels__menu">
            <tooltipUI text="Editor de Laudo" placement="left" :disabled="expandedPanelId == 'relatorio'">
                <div class="button" @click="toggleExpanded('relatorio')" :data-active="expandedPanelId == 'relatorio'">
                    <RelatorioIconSvg class="button__icon" />
                </div>
            </tooltipUI>
            <!-- <div class="button" @click="toggleExpanded('pesquisa')" :data-active="expandedPanelId == 'pesquisa'">
                <SearchIconSvg class="button__icon" />
            </div> -->
            <tooltipUI text="Estruturas Anatômicas" placement="left" :disabled="expandedPanelId == 'anatomia'">
                <div class="button" @click="toggleExpanded('anatomia')" :data-active="expandedPanelId == 'anatomia'">
                    <PanelAnatomiaIconSvg class="button__icon" />
                </div>
            </tooltipUI>
        </div>

        <LabelSearchPopup v-if="expandedPanelId !== 'relatorio'" :rightOffset="hasExpandedPanel ? panelWidth : 0" />
    </div>
</template>

<script>
import RelatorioIconSvg from '@/assets/icons/relatorio.svg';
import SearchIconSvg from '@/assets/icons/search.svg';
import PanelAnatomiaIconSvg from '@/assets/icons/panel/panel-anatomia.svg';
import ArrowDownSvg from '@/assets/icons/arrow-down.svg';
import { evtBus } from '@/main';
import { gConsts } from '@/globals/gConsts';
import RelatorioDinamicoPanel from '../panels/relatorioDinamico/relatorioDinamico.vue';
import PesquisaAnotacoesPanel from '../panels/pesquisaAnotacoes/pesquisaAnotacoes.vue';
import AnatomiaPanel from '../panels/anatomia/anatomiaPanel.vue';
import LabelSearchPopup from '../panels/pesquisaAnotacoes/new-label/labelSearchPopup.vue';
import tooltipUI from '@/components/ui/tooltip.vue';

const MIN_PANEL_WIDTH = 400;
const MAX_PANEL_WIDTH = 700;

export default {
    name: 'sidebarPanels',

    components: {
        RelatorioIconSvg,
        // SearchIconSvg,
        PanelAnatomiaIconSvg,
        ArrowDownSvg,
        RelatorioDinamicoPanel,
        // PesquisaAnotacoesPanel,
        AnatomiaPanel,
        LabelSearchPopup,
        tooltipUI,
    },

    data() {
        return {
            expandedPanelId: null,
            panelWidth: 450,
            resizing: {
                active: false,
                startX: 0,
                startWidth: 0,
            },
            source: null,
            gConsts: gConsts,
        }
    },

    watch: {
        expandedPanelId(newVal, oldVal) {
            if (oldVal == 'relatorio') {
                // Remove linhas sem anotacoes do relatorio quando o painel de relatorio é fechado
                this.$store.dispatch('ACT_reportNodes_removeEmptyReportLabels');
            }
            if ([newVal, oldVal].includes('anatomia')) {
                evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: newVal == 'anatomia' ? 'step_anatomia' : null, nodeType: gConsts.node.layout.types.STEP });
            }
        }
    },

    computed: {
        hasExpandedPanel() {
            return this.expandedPanelId != null;
        }
    },

    methods: {

        startResizing(event) {
            this.resizing.active = true;
            this.resizing.startX = event.clientX;
            this.resizing.startWidth = this.panelWidth;
            document.body.style.cursor = 'col-resize';
            document.body.style.userSelect = 'none';
            window.addEventListener('mousemove', this.onResizePanel);
            window.addEventListener('mouseup', this.stopResizing);
        },

        onResizePanel(event) {
            const requestedWidth = this.resizing.startWidth + this.resizing.startX - event.clientX;
            this.panelWidth = Math.min(MAX_PANEL_WIDTH, Math.max(MIN_PANEL_WIDTH, requestedWidth));
        },

        stopResizing() {
            if (!this.resizing.active)
                return;

            this.resizing.active = false;
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            window.removeEventListener('mousemove', this.onResizePanel);
            window.removeEventListener('mouseup', this.stopResizing);
        },

        toggleExpanded(panelId) {
            const newExpandedPanelId = (this.expandedPanelId === panelId) ? null : panelId;
            if (this.shouldFitToWorkArea(newExpandedPanelId, this.expandedPanelId)) {
                this.fitToWorkArea();
            }
            this.source = null;
            this.expandedPanelId = newExpandedPanelId;
            if (this.expandedPanelId == null) {
                evtBus.$emit('evt_sidebarPanel_onCollapse');
            } else {
                evtBus.$emit('evt_sidebarPanel_onExpanded', panelId);
            }
        },

        shouldFitToWorkArea(newPanelId, oldPanelId) {
            if (newPanelId == null)
                return true
            // Caso esteja abrindo o relatorio apenas. Se abrir a pesquisa ele nao diminui a imagem do workarea
            return ['relatorio', 'anatomia'].includes(newPanelId);
        },

        fitToWorkArea() {
            // Espero terminar a transicao do painel
            setTimeout(() => {
                evtBus.$emit('evt_medidor_fitToWorkArea');
            }, 300)
        },

    },

    created() {

        evtBus.$on('evt_sidebarPanel_collapse', () => {
            if (this.source == 'relatorio') {
                this.expandedPanelId = 'relatorio';
                return
            }
            console.log('evt_sidebarPanel_collapse');
            this.expandedPanelId = null;
            this.source = null;
            evtBus.$emit('evt_sidebarPanel_onCollapse');
            this.fitToWorkArea();
        });

        // evtBus.$on('evt_pesquisaAnotacoes_action', (action, payload) => {
        //     console.log('evt_pesquisaAnotacoes_action: ', action, payload);
        //     if (action == 'search' && this.expandedPanelId != 'pesquisa') {
        //         this.expandedPanelId = 'pesquisa';
        //         this.source = payload.source ?? null;
        //     }
        // });

    },

    beforeDestroy() {
        this.stopResizing();
    },
}
</script>

<style scoped>
.sidebar-panels__container {
    display: flex;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background-color: var(--background-white);
}

.sidebar-panels__menu {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: var(--spacing);
    padding: var(--spacing) var(--spacing-sm);
    border-left: 1px solid var(--border-primary);
    background-color: var(--background-gray);
}

.sidebar-panels__menu .button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--color-gray);
    border-radius: var(--radius-sm);
    padding: var(--spacing-sm);
    color: var(--color-primary);
    transition: all 0.2s ease;
    cursor: pointer;
}

.sidebar-panels__menu .button__icon {
    width: 24px;
    height: 24px;
}

.sidebar-panels__menu .button:hover {
    opacity: 0.7;
}

.sidebar-panels__menu .button[data-active="true"] {
    background-color: var(--color-primary);
    color: var(--color-white);
}

.sidebar-panels__content {
    position: relative;
    height: 100%;
    width: 0;
    overflow: hidden;
    border-left: 1px solid var(--border-primary);
    transition: width 0.3s ease;
}

.sidebar-panels__content[data-expanded="true"] {
    width: var(--sidebar-panel-width);
}

.sidebar-panels__content[data-resizing="true"] {
    transition: none;
}

.sidebar-panels__resize-handle {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 7px;
    transform: translateX(-50%);
    cursor: col-resize;
    z-index: 101;
}

.sidebar-panels__resize-handle::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 2px;
    background-color: transparent;
    transform: translateX(-50%);
    transition: background-color 0.15s ease;
}

.sidebar-panels__resize-handle:hover::after,
.sidebar-panels__resize-handle[data-resizing="true"]::after {
    background-color: var(--color-primary);
}

.sidebar-panels__container .close_button {
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translate(-65%, -100%);
    background-color: var(--color-gray);
    border-radius: 50%;
    padding: var(--spacing-xs);
    color: var(--color-primary);
    transition: all 0.2s ease;
    cursor: pointer;
    z-index: 102;
}

.sidebar-panels__container .close_button:hover {
    opacity: 0.7;
}

.sidebar-panels__container .close_button__icon {
    width: 24px;
    height: 24px;
    rotate: -90deg;
}

.fade-in {
    animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
</style>